import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';

@Component({
  selector: 'app-r-con-timestamp',
  templateUrl: './r-con-timestamp.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RConTimestampComponent),
      multi: true
    }
  ]
})
export class RConTimestampComponent extends RenderComponentBase {
  static KEY = 'r-d-con-timestamp';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {}
}
